<template>
  <div class="selector pt-0">
    
    <!--<div class="selector__content selector__toggle-action form__field flex justify-between items-center" @click="open = !open">-->
      <!--<div class="form__label">-->
        <!--<h3 class="selector__title">Settings</h3>-->
      <!--</div>-->
      <!--<div>-->
        <!--<button class="selector-button__toggle-action" :class="open ? 'open' : 'closed'"></button>-->
      <!--</div>-->
    <!--</div>-->
    <div v-if="isMobile" class="flex justify-between mb-4 px-2">
      <div class="py-1 px-4 text-xsm settings-tabs__button" :class="currentTab === 1 ? 'active' : ''" @click="currentTab = 1">Rotation</div>
      <div class="py-1 px-4 text-xsm settings-tabs__button" :class="currentTab === 2 ? 'active' : ''" @click="currentTab = 2">Scale</div>
      <div class="py-1 px-4 text-xsm settings-tabs__button" :class="currentTab === 3 ? 'active' : ''" @click="currentTab = 3">H offset</div>
      <div class="py-1 px-4 text-xsm settings-tabs__button" :class="currentTab === 4 ? 'active' : ''" @click="currentTab = 4">V offset</div>
    </div>

    <transition name="slide-up">
      <div v-if="open" class="selector__controls-wrapper mb-0 lg:px-0 lg:mb-12">

        <div v-if="!isMobile || currentTab === 1" class="flex flex-col-reverse">
          <vue-slider key="texture-rotation" class="mt-0 lg:mt-2 mb-2 lg:mb-10 mx-3" :disabled="!selectedTexture" v-model="rotation" :marks="degreesMarks"  :min="-180" :max="180" :interval="1"></vue-slider>
          <h4 v-if="!isMobile" class="text-xsm lg:text-n pl-3 text-center lg:text-left uppercase text-button">Rotation</h4>
        </div>
        <div  v-if="!isMobile || currentTab === 2" class="flex flex-col-reverse">
          <vue-slider key="texture-scale" class="mt-0 lg:mt-2 mb-2 lg:mb-10 mx-3" :disabled="!selectedTexture" v-model="scale" :marks="scaleMarks"  :min="0.25" :max="2.00" :interval="0.05"></vue-slider>
          <h4 v-if="!isMobile" class="text-xsm lg:text-n pl-3 text-center lg:text-left uppercase text-button">Scale</h4>
        </div>
        <div  v-if="!isMobile || currentTab === 3" class="flex flex-col-reverse">
          <vue-slider key="texture-x" class="mt-0 lg:mt-2 mb-2 lg:mb-10 mx-3" :disabled="!selectedTexture" v-model="offsetX"  :min="-10.0" :max="10.0" :interval="0.1"></vue-slider>
          <h4 v-if="!isMobile" class="text-xsm lg:text-n pl-3 text-center lg:text-left uppercase text-button">Horizontal offset</h4>
        </div>

        <div  v-if="!isMobile || currentTab === 4" class="flex flex-col-reverse">
          <vue-slider key="texture-y" class="mt-0 lg:mt-2 mb-2 lg:mb-10 mx-3" :disabled="!selectedTexture" v-model="offsetY"  :min="-10.0" :max="10.0" :interval="0.1"></vue-slider>
          <h4  v-if="!isMobile" class="text-xsm lg:text-n pl-3 text-center lg:text-left uppercase text-button">Vertical offset</h4>
        </div>

        <div v-if="!isMobile" class="text-right">
          <button @click="resetControls" :disabled="!changed" :class="{ 'changed': changed }" class="selector__button selector__button--red">reset</button>
        </div>
        <div class="flex justify-center items-center pt-5" v-else>
          <span class="mr-4">reset all settings</span>
          <button @click="resetControls" class="button button__grey settings-refresh" :disabled="!changed" :class="{ 'changed': changed }">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path></svg>
          </button>
        </div>

      </div>
    </transition>

    

  </div>
</template>

<script>
  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/default.css'
  import { gsap } from 'gsap';
  import { isMobile } from 'mobile-device-detect'

  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: "TextureTransformSelectors",
    components: {
      VueSlider
    },
    data() {
      return {
        open: true,
        isMobile: isMobile,
        rotation: 0,
        scale: 1.0,
        offsetX: 0.0,
        offsetY: 0.0,
        changed: false,
        degreesMarks: {
          '-180' : '-180°',
          '-90' : '-90°',
          '0' : '0°',
          '90' : '90°',
          '180' : '180°',

        },
        scaleMarks: {
          '0.25' : '25%',
          '0.50' : '50%',
          '1.00' : '100%',
          '1.50' : '150%',
          '2.00' : '200%',
        },
        currentTab: 1,
      }
    },
    computed: {
      ...mapGetters('textures',[
        'selectedTexture',
      ]),
      ...mapGetters('clothes',[
        'selectedMesh',
      ]),
      ...mapGetters('snapshots',[
        'snapshots',
      ])
    },
    watch: {
      rotation: function(val) {
        // console.log(val);
        this.changed = (val !== this.selectedMesh.material.userData.uniforms.tRotation.value);
        if(this.selectedTexture)
          this.setTextureRotation(val).then( ( {tRotation} ) => {
            if(tRotation !== val)
              gsap.to(tRotation,{duration: 1, value: val, ease: 'expo.out', onUpdate: this.render });
        });
      },
      scale: function(val) {
        //console.log(val);
        this.changed = (val !== this.selectedMesh.material.userData.uniforms.tScale.value);
        if(this.selectedTexture)
          this.setTextureScale(val).then( ( {tScale} ) => {
            if(tScale !== val)
              gsap.to(tScale,{duration: 1, value: val, ease: 'expo.out', onUpdate: this.render, onComplete: this.printSnapshots });
          });
      },
      offsetX: function(val) {
        // console.log(val);
        this.changed = (val !== this.selectedMesh.material.userData.uniforms.tOffsetX.value);
        if(this.selectedTexture)
          this.setTextureOffset( { x: val, y: this.offsetY } ).then( ( {tOffsetX} ) => {
            if(tOffsetX !== val)
              gsap.to(tOffsetX,{duration: 1, value: val, ease: 'expo.out', onUpdate: this.render });
          });
      },
      offsetY: function(val) {
        // console.log(val);
        this.changed = ( val !== this.selectedMesh.material.userData.uniforms.tOffsetY.value);
        if(this.selectedTexture)
          this.setTextureOffset( { x: this.offsetX, y: val } ).then( ( {tOffsetY} ) => {
            if(tOffsetY !== val)
              gsap.to(tOffsetY,{duration: 1, value: val, ease: 'expo.out', onUpdate: this.render });
          });
      },
      selectedMesh: function() {
        if(this.selectedMesh.material.userData.uniforms) {
          this.setControls(this.selectedMesh.material.userData.uniforms);
        } else {
          this.resetControls();
        }
      },
      selectedTexture: function() {
        if(this.selectedMesh) {
          this.setControls(this.selectedMesh.material.userData.uniforms);
        }
      }
    },
    methods: {
      ...mapActions('textures',[
        'setTextureScale',
        'setTextureRotation',
        'setTextureOffset'
      ]),
      ...mapActions([
        'render',
      ]),
      resetControls() {
        this.scale = 1.0;
        this.rotation = 0;
        this.offsetX = 0.0;
        this.offsetY = 0.0;
        setTimeout(() => { this.changed = false},500);
      },
      setControls({ tRotation, tScale, tOffsetX, tOffsetY }) {
        // console.log('setControls'); //todo perchè noin aggiorna gli slider quando carico un outtif
        this.rotation = tRotation.value;
        this.scale = tScale.value;
        this.offsetX = tOffsetX.value;
        this.offsetY = tOffsetY.value;
      },
      printSnapshots() {
        // console.log(this.snapshots);
      }
    },
    mounted() {

      // console.log('selected uniforms',this.selectedMesh.material.userData.uniforms);

      if(this.selectedMesh.material && this.selectedMesh.material.userData.uniforms) {
        this.setControls(this.selectedMesh.material.userData.uniforms);
        // console.log('selected uniforms',this.selectedMesh.material.userData.uniforms);
        // console.log('snapshots',this.snapshots);
      } else {
        this.resetControls();
      }

      // if(!this.selectedTexture) {
      //   this.resetControls();
      // }
    }
  }
</script>

<style scoped>
  .slide-up-enter-active {
    transition: all .6s ease-in-out;
  }
  .slide-up-leave-active {
    transition: all .6s ease-in-out;
  }
  .slide-up-enter, .slide-up-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateY(30px);
    opacity: 0;
  }

  .selector-button__toggle-action {
    displaY: inline-block;
    height: 42px;
    width: 42px;
    text-align: center;
    line-height: 42px;
    border-radius: 42px;
    /*border: 1px solid #7C7C7C;*/
    font-size: 35px;
    font-weight: 300;
    position: relative;
  }

  .selector-button__toggle-action::after {
    content: '';
    display: block;
    position: absolute;
    height: 15px;
    width: 15px;
    border: 1px solid #7C7C7C;
    border-left-color: transparent;
    border-top-color: transparent;
    transform: rotateX(0deg) rotateZ(45deg);
    left: 12.5px;
    top: 12.5px;
    transition: all 0.3s ease-in-out;
    z-index: 10;
    transform-origin: center;
  }

  .selector-button__toggle-action.open::after {
    transform: rotateX(180deg) rotateZ(45deg);
    top: 15px;
  }

  .selector__toggle-action {
    cursor: pointer;
  }

  .selector {
    /*border-bottom: 1px solid #CAC8C8;*/
    padding-bottom: 25px;
  }

  .selector__button {
    height: 40px;
    line-height: 40px;
    text-align: center;
    display: inline-block;
    padding: 0 20px;
    background-color: #CCCCCC;
    transition: all 0.3s ease-in-out;
    margin-top: 20px;
  }

  .selector__button.selector__button--red {
    background-color: red;
    border: 1px solid red;
    color: white;
  }

  .selector__button:disabled {
    opacity: 0.4;
  }

  .button {
    padding: 0px;
    /* font-size: 14px; */
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .button__grey {
    color: white;
    background-color: #7C7C7C;
    border: 1px solid #7C7C7C;
    opacity: 0.3;
  }

  .button__grey.changed {
    opacity: 1;
  }

  .settings-tabs__button {
    border-radius: 100px;
    color: #7C7C7C;
    border: 1px solid #7C7C7C;
  }

  .settings-tabs__button.active {
    color: red;
    border-color: red;
  }

</style>